import axios from "axios";
import * as actionTypes from "./actionTypes";
import Cookies from 'universal-cookie';
import {loginURL} from "../../constants";
import {openNotificationWithIcon} from "../../containers/Function";
import JsCookies  from 'js-cookie';

const cookies = new Cookies();


export const authStart = () => {
  return {
    type: actionTypes.AUTH_START
  };
};

export const authSuccess = token => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    token: token
  };
};

export const authFail = error => {
  return {
    type: actionTypes.AUTH_FAIL,
    error: error
  };
};

export const logout = () => {
  JsCookies.remove('refresh', { domain: '.rainscales.com.vn' });
  JsCookies.remove('token', { domain: '.rainscales.com.vn' });
  // JsCookies.remove('refresh', { domain: '.dri.io.vn' });
  // JsCookies.remove('token', { domain: '.dri.io.vn' });
  JsCookies.remove('token');
  JsCookies.remove('refresh');
  // Xóa toàn bộ cookies có thể do khởi tạo nhiều
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
  return {
    type: actionTypes.AUTH_LOGOUT
  };
};

export const checkAuthTimeout = expirationTime => {
  return dispatch => {
    setTimeout(() => {
      dispatch(logout());
    }, expirationTime * 1000); // 3600 * 1000 = 3600000 mili giây = 60 phút = 1 giờ
  };
};

export const authLogin = (username, password) => {
  return dispatch => {
    dispatch(authStart());
    axios
      .post(loginURL, {
        username: username,
        password: password
      })
      .then(res => {
        const token = res.data.access;
        const refresh = res.data.refresh;
        cookies.set('token',token); // dùng nếu chạy ip local
        cookies.set('refresh',refresh); // dùng nếu chạy ip local

        dispatch(authSuccess(token));

        // 081124 checkAuthTimeout tự dộng logout theo thời gian (nếu ACCESS_TOKEN_LIFETIME và REFRESH_TOKEN_LIFETIME của api hết hạn thì token hết hạn cũng logout)
        // để cho chắc set logout cùng thời gian với ACCESS_TOKEN_LIFETIME
        // hiện tại là 7 day phía api server, 6 day phía FE client
        dispatch(checkAuthTimeout(6 * 24 * 3600)); //  6 * 24 * 3600 = 6 day

      })
      .catch(err => {
        if (err.request.status === 0) {
          openNotificationWithIcon('error','Lỗi kết nối','Lỗi kết nối, kiểm tra kết nối tới server !!!')
          // message.error('Lỗi kết nối, kiểm tra kết nối tới server !!!', 10);

        }
         dispatch(authFail(err));
      });
  };
};


export const authCheckState = () => {
  return dispatch => {
    const token = cookies.get("token");
    if (token === undefined) {
      dispatch(logout());
    } else {
        dispatch(authSuccess(token));
    }
  };
};

